import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { ownedParkingKeys } from '../../constants/ownedParkings';
export function useInvalidateOwnedParkings() {
    const queryClient = useQueryClient();
    return useCallback(() => {
        return queryClient.invalidateQueries({ queryKey: ownedParkingKeys.all });
    }, [queryClient]);
}
